export default __webpack_public_path__ + "static/media/FontAwsome (angle-double-left).f6bb03b1.svg";